import React from 'react';
import MyoPizzaDisplay from '../../Components/MyoPizzaDisplay/myoPizzaDisplay';
import Navbar from '../../Components/Navbar/Navbar';
export default function MyoPizza() {
	return (
		<div>
			<Navbar />
			<MyoPizzaDisplay />
		</div>
	);
}
